import * as z from 'zod';

export const billingTermQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
  calendar_days: z.number().nullish(),
});

export type BillingTermQueryLinkerSchema = z.infer<typeof billingTermQueryLinkerSchema>;
